import './index.scss';

import React from 'react';
import {resolveBarcode} from "../../../util/barcode";

import Form from "../form";
import TextInput from "../../atoms/text-input";
import Button from "../../atoms/button";
import Loader from "../../atoms/loader";

class BarcodeScanner extends React.Component {

    static defaultProps = {
        defaultValues: null,
        showErrors: true,
        isLoading: false,
        isScanning: false,
        list: 'releases',
        onReleaseFound: (release) => {},
        onMultipleReleasesFound: (releases, barcode) => {},
        onProductFound: (product) => {},
        onReleaseNotFound: (barcode) => {},
        onOrderFound: (order) => {},
        onMultipleOrdersFound: (orders, barcode) => {},
        onOrderNotFound: (order) => {},
        onSecondHand: () => {},
        onBxlStock: () => {},
        onPlasticBag: () => {},
        onGiftcardFound: () => {},
        onCustomProductTypeFound: () => {},
    };

    constructor(props) {
        super(props);

        this.state = {
            isScanning: this.props.isScanning
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isScanning !== prevProps.isScanning) {
            this.toggleScanning();
        }
    }

    activateScanning() {
        this.setState({isScanning: true});
    }

    deactivateScanning() {
        this.setState({isScanning: false});
    }

    toggleScanning() {
        this.setState({isScanning: !this.state.isScanning});
    }

    toggleLoading() {
        this.setState({isLoading: !this.state.isLoading});
    }

    // Entry point for a scan that did not come through this component's own input:
    // show the scanning state so it reads as a regular scan, then handle the code.
    scan(barcode) {
        this.setState({isScanning: true});

        this.searchByBarcode(barcode);
    }

    searchByBarcode(barcode) {
        resolveBarcode(barcode, {
            list: this.props.list,
            defaultValues: this.props.defaultValues,
            showErrors: this.props.showErrors,
            onLoadingChange: (isLoading) => this.setState({isLoading: isLoading}),
            handlers: {
                onReleaseFound: this.props.onReleaseFound,
                onMultipleReleasesFound: this.props.onMultipleReleasesFound,
                onProductFound: this.props.onProductFound,
                onReleaseNotFound: this.props.onReleaseNotFound,
                onOrderFound: this.props.onOrderFound,
                onMultipleOrdersFound: this.props.onMultipleOrdersFound,
                onOrderNotFound: this.props.onOrderNotFound,
                onSecondHand: this.props.onSecondHand,
                onBxlStock: this.props.onBxlStock,
                onPlasticBag: this.props.onPlasticBag,
                onGiftcardFound: this.props.onGiftcardFound,
                onCustomProductTypeFound: this.props.onCustomProductTypeFound,
            },
        });
    }

    getScanContent() {
        if (this.state.isLoading) {
            return <Loader isLoading={true}/>;
        }

        if (this.state.isScanning) {
            return (
                <Form showSubmitButton={false} onSubmit={data => this.searchByBarcode(data.barcode)}
                      clearOnSubmit={true}>
                    <TextInput name={'barcode'} placeholder={'Scan your barcode'} focus={true}
                               onBlur={this.deactivateScanning.bind(this)} modifiers={['center', 'negative']}/>
                </Form>
            );
        }

        return (
            <Button text="Activate barcode scanner" modifiers={['stretch', 'transparent']}/>
        );
    }

    render() {
        return (
            <div className={'barcode-scanner' + (this.state.isScanning ? ' barcode-scanner--active' : '')}
                 onClick={this.activateScanning.bind(this)}>
                {this.getScanContent()}
            </div>
        );
    }
}

export default BarcodeScanner;